export const SUBSCRIBE = "SUBSCRIBE";
export const SUBSCRIBE_SUCCESS = "SUBSCRIBE_SUCCESS";
export const SUBSCRIBE_FAILD = "SUBSCRIBE_FAILD";